ixModuleRouting("impactx.themeconfigurator", {
    "/themeconfigurator": {
        template: "<ixa-theme-configurator></ixa-theme-configurator>",
        process: "ThemeConfigurator",
        workspace: "system",
    },
    "/themeconfigurator/:comId": {
        template: "<ixa-theme-configurator></ixa-theme-configurator>",
        process: "ThemeConfiguratorCompany",
        workspace: "admin",
    },
});
